import PlayerService from '../PlayerService';

class LiveService extends PlayerService {
  get liveTracker() {
    const liveTracker = this._playerInstance?.liveTracker;
    if (!liveTracker) return null;

    return {
      ...liveTracker,
      atLiveEdge: liveTracker.atLiveEdge(),
      seekableStart: liveTracker.seekableStart(),
      liveWindow: liveTracker.liveWindow(),
      liveCurrentTime: liveTracker.liveCurrentTime(),
      seekToLiveEdge: () => liveTracker.seekToLiveEdge(),
    };
  }

  get percentWatched() {
    if (!this.hasPlayerInstance() || !this.liveTracker) return 0;

    if (this.liveTracker.atLiveEdge) return 100;

    const currentTime = this.currentTime;

    return (currentTime * 100 - this.liveTracker.seekableStart) / this.liveTracker.liveWindow;
  }

  isCloseToLiveEdge() {
    const TIME_OFFSET = 7;

    const liveCurrentTime = this.liveTracker?.liveCurrentTime || 0;
    const currentTime = this.currentTime;

    if (!liveCurrentTime) return false;

    return currentTime + TIME_OFFSET >= liveCurrentTime;
  }

  setCurrentTimePercent(percent: number) {
    if (!this.liveTracker) return;

    let newTime: number;

    if (percent >= 99) {
      this.liveTracker.seekToLiveEdge();
      return;
    }

    const seekableStart = this.liveTracker.seekableStart;
    const seekableEnd = this.liveTracker.liveCurrentTime;

    newTime = seekableStart + (this.liveTracker.liveWindow / 100) * percent;

    if (newTime >= seekableEnd) {
      newTime = seekableEnd;
    } else if (newTime <= seekableStart) {
      newTime = seekableStart + 100;
    } else if (newTime === Infinity) {
      return;
    }

    this.setCurrentTime(newTime);
  }
}

export default LiveService;
